import * as React from 'react';

function Novelty(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M17.978 3c.016.138.024.279.024.425 0 .109 0 .218-.003.327a3 3 0 11-1.209 5.744c-.804 1.788-1.956 3.111-3.287 3.688V16.5h3.749V21h-10.5v-4.5h3.75v-3.317c-1.33-.575-2.483-1.9-3.289-3.689a3 3 0 11-1.21-5.743v-.326c0-.146.007-.287.024-.425h11.95zm-2.226 15h-7.5v1.5h7.5V18zM6.003 5.25a1.5 1.5 0 10.68 2.838 14.942 14.942 0 01-.581-2.834 1.635 1.635 0 00-.099-.003zm12 0l-.1.004c-.102.96-.296 1.91-.58 2.833a1.5 1.5 0 10.679-2.837z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Novelty;
